import Button from '@doordash/component-button'
import { Inset, Stack, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import StickyBottom from '../../../components/atoms/sticky-bottom'
import { WorkflowErrorType } from '../../../components/pages/onboarding-workflow/OnboardingWorkflow'
import useHeightObserver from '../../../hooks/useHeightObserver'
import { addResizeObserverToElement } from '../../../utilities/resizeObserver'
import { getIsMobile } from '../../../utilities/userAgent'
import FullHeightWrapper from '../../atoms/full-height-wrapper'
import SimpleSpacer from '../../atoms/simple-spacer'
import s from './strings'

export enum WORKFLOW_ERROR_TYPES {
  DOC_UPLOAD = 'DOC_UPLOAD',
  GENERIC = 'GENERIC',
}

type WorkflowErrorProps = {
  error: WorkflowErrorType
  onRetry: () => void
}

export const WorkflowError: React.FC<WorkflowErrorProps> = ({
  error,
  onRetry,
}) => {
  const { status, message, type } = error
  const onClick = () => {
    onRetry()
  }

  const {
    height: footerHeight,
    resizeObserver: footerResizeObserver,
  } = useHeightObserver()

  const isMobile = getIsMobile()

  const heading =
    type === WORKFLOW_ERROR_TYPES.DOC_UPLOAD
      ? s.documentUploadErrorTitle()
      : s.genericErrorTitle()

  let content =
    type === WORKFLOW_ERROR_TYPES.DOC_UPLOAD
      ? s.documentUploadErrorContent()
      : s.genericErrorContent()
  if (status !== 500) {
    content = `${content} Error: ${message}` // add server-provided message for non-500 errors
  }

  return (
    <FullHeightWrapper isMobile={isMobile}>
      <Inset size={Inset.Sizes.Large} horizontalSize={Inset.Sizes.XxxSmall}>
        <StackChildren size={StackChildren.Sizes.Large}>
          <Text styles={Text.Styles.Title1}>{heading}</Text>
          <Text styles={Text.Styles.Body1}>{content}</Text>
        </StackChildren>
      </Inset>
      {isMobile && <SimpleSpacer $height={footerHeight} />}
      <StickyBottom isMobile={isMobile}>
        <div ref={addResizeObserverToElement(footerResizeObserver)}>
          <Stack size={StackChildren.Sizes.XxSmall}>
            <Button data-testid="ctaButton" onClick={onClick}>
              {s.retry()}
            </Button>
          </Stack>
        </div>
      </StickyBottom>
    </FullHeightWrapper>
  )
}
